import naturalAddSimple from '@/adapters/primitive/_data/visualSources/natural-add-simple.json' with { type: 'json' };
import naturalWheel123 from '@/adapters/primitive/_data/visualSources/natural-wheel-123.json' with { type: 'json' };
import { parsePrimitiveVisualSources } from '@/adapters/primitive/_pure/episode';

export const primitiveVisualSources = parsePrimitiveVisualSources([naturalAddSimple, naturalWheel123]);
